import PhotoSwipeLightbox from './photoswipe-lightbox.esm.js';
import { ThemeEvents } from '@theme/events';

class ProductMediaGallery extends HTMLElement {
  initLightbox() {
    if (this.dataset.enableLightbox !== 'true') return;

    const gallery = this.querySelector(
      '.product-media-gallery-main-slider'
    );

    if (!gallery) return;

    if (gallery.photoswipeInstance) {
      gallery.photoswipeInstance.destroy();
    }

    const lightbox = new PhotoSwipeLightbox({
      gallery: `#${gallery.id}`,
      children: '.product-media-gallery__lightbox-item',
      pswpModule: () => import('./photoswipe.esm.js'),
    });

    lightbox.init();

    gallery.photoswipeInstance = lightbox;
  }

  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
    this.initLightbox();
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
  }

  updateMediaGallery = (event) => {
    const newMediaGallery = event.detail.data.html.querySelector('product-media-gallery slider-component');
    const currentMediaGallery = this.querySelector('slider-component');

    if (!newMediaGallery || !currentMediaGallery) return;

    if (currentMediaGallery.innerHTML !== newMediaGallery.innerHTML) {
      currentMediaGallery.replaceWith(newMediaGallery);
      this.initLightbox();
    }
  };
}

if (!customElements.get('product-media-gallery')) {
  customElements.define('product-media-gallery', ProductMediaGallery);
}
